import 'flatpickr/dist/flatpickr.min.js';
import 'jquery.cookie';

var local = {};

(function (localApp) {
	var filterModel = {
		SearchTerm: "",
		SearchQuickDate: "",
		SearchDateFrom: "",
		SearchDateTo: "",
		LocalTag: "",
		Cost: "",
		Category: "",
		ArticlePage: 1,
		EventPage: 1
	};
	var fp = null;
	var cookieName = "_oa_localCk";
	var fromPopState = false;
	var blockPopstateEvent = true;
	var browserSupportsHistoryApi = window.history && 'pushState' in window.history;

	if (browserSupportsHistoryApi) {
		// prevent Chrome from calling onpopstate on initial load
		$(window).on('load', function () {
			// The timeout ensures that popstate-events will be unblocked right
			// after the load event occured, but not in the same event-loop cycle.
			setTimeout(function () { blockPopstateEvent = false; }, 0);
		});

		$(window).on('popstate', function () {
			if (blockPopstateEvent && document.readyState === "complete") {
				return;
			}
			fromPopState = true;
			performSearchFromUrl();
		});
	}

	function pushHistory() {
		if (browserSupportsHistoryApi && !fromPopState) {
			var currentPath = window.location.pathname;
			var query = "?";
			var queryArray = [];
			if (filterModel.SearchTerm) {
				queryArray.push("search=" + filterModel.SearchTerm);
			}
			if (filterModel.SearchQuickDate) {
				queryArray.push("searchQuickDate=" + filterModel.SearchQuickDate);
			}
			if (filterModel.ArticlePage) {
				queryArray.push("articlepage=" + filterModel.ArticlePage);
			}
			if (filterModel.EventPage) {
				queryArray.push("eventpage=" + filterModel.EventPage);
			}
			if (filterModel.LocalTag) {
				queryArray.push("local=" + filterModel.LocalTag);
			}
			if (filterModel.Category) {
				queryArray.push("category=" + filterModel.Category);
			}
			if (filterModel.SearchDateFrom) {
				queryArray.push("searchDateFrom=" + filterModel.SearchDateFrom);
			}
			if (filterModel.SearchDateTo) {
				queryArray.push("searchDateTo=" + filterModel.SearchDateTo);
			}
			if (filterModel.Cost) {
				queryArray.push("cost=" + filterModel.Cost);
			}
			query += queryArray.join("&");
			history.pushState(null, null, currentPath + query);
		}
		fromPopState = false;
	}

	function performSearchFromUrl() {
		filterModel.SearchTerm = null;
		filterModel.SearchQuickDate = null;
		filterModel.LocalTag = null;
		filterModel.Category = null;
		filterModel.SearchDateFrom = null;
		filterModel.SearchDateTo = null;
		filterModel.Cost = null;
		filterModel.ArticlePage = 1;
		filterModel.EventPage = 1;
		localApp.setInputValue();

		if (window.location.search.length > 1) {
			for (var aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
				nKeyId < aCouples.length;
				nKeyId++) {
				aItKey = aCouples[nKeyId].split("=");
				if (aItKey.length <= 1)
					continue;
				var key = decodeURIComponent(aItKey[0]).toLowerCase();
				var val = decodeURIComponent(aItKey[1]);

				if (key === "search") {
					filterModel.SearchTerm = val;
				} else if (key === "searchQuickDate") {
					filterModel.SearchQuickDate = val;
				} else if (key === "articlepage") {
					filterModel.ArticlePage = val;
				} else if (key === "eventpage") {
					filterModel.EventPage = val;
				} else if (key === "local") {
					filterModel.LocalTag = val;
				} else if (key === "category") {
					filterModel.Category = val;
				} else if (key === "searchDateFrom") {
					filterModel.SearchDateFrom = val;
				} else if (key === "searchDateTo") {
					filterModel.SearchDateTo = val;
				} else if (key === "cost") {
					filterModel.Cost = val;
				}
				localApp.setInputValue();
			}
		}
		localApp.GetSearchResults();
	}

	localApp.setHeroImage = function () {
		var heroImageUrl = $("#area-select").find(':selected').data('local-image');
		var heroImageUrlSrcset = $("#area-select").find(':selected').data('local-image-srcset');
		var localName = $("#area-select").find(':selected').data('local-name');

		if (heroImageUrl !== null && heroImageUrl !== "" && typeof heroImageUrl !== 'undefined' && heroImageUrlSrcset !== null && heroImageUrlSrcset !== "" && typeof heroImageUrlSrcset !== 'undefined') {

			if ($('.js-hero-image').length) {
				$('.js-hero-image').attr('src', heroImageUrl);
				$('.js-hero-image').attr('srcset', heroImageUrlSrcset);
			} else {
				//add img if it doesn't exist
				$('.listing-page__background').prepend('<img srcset="' + heroImageUrlSrcset + '" src="' + heroImageUrl + '" alt="' + localName + ' hero image" class="js-hero-image">');
			}

		}
	}

	localApp.setPageTitle = function () {
		var title = $("#area-select").find(':selected').data("local-name");
		title = title === null || title === "" || title === undefined ? "Local" : title;
		$(".js-page-title").text(title);

		$(".js-local-section-title-news").text(title + ' News');
		$(".js-local-section-title-events").text(title + ' Events');
		$(".js-local-not-found-title").text(title);
	}

	localApp.setInputValue = function () {
		$("#search").val(filterModel.SearchTerm);
		$("#searchMobile").val(filterModel.SearchTerm);
		$("#area-select").val(filterModel.LocalTag);
		$("#searchQuickDate").val(filterModel.SearchQuickDate);
		$("#searchCategory").val(filterModel.Category);
		$('#searchDateFrom').val(filterModel.SearchDateFrom);
		$('#searchDateTo').val(filterModel.SearchDateTo);
		$("#cost").val(filterModel.Cost);

		var hasCategory = filterModel.Category !== null && filterModel.Category !== "" && typeof filterModel.Category !== 'undefined';
		var hasDateFrom = filterModel.SearchDateFrom !== null && filterModel.SearchDateFrom !== "" && typeof filterModel.SearchDateFrom !== 'undefined';
		var hasDateTo = filterModel.SearchDateTo !== null && filterModel.SearchDateTo !== "" && typeof filterModel.SearchDateTo !== 'undefined';
		var hasCost = filterModel.Cost !== null && filterModel.Cost !== "" && typeof filterModel.Cost !== 'undefined';
		if (hasCategory || hasCost || hasDateFrom || hasDateTo) {
			$(".js-toggle-advanced-search").click();

			if (hasCategory) {
				var choicesToSet = filterModel.Category.split(',');
				window.choices.setChoiceByValue(choicesToSet);
			}

			if (fp !== null && (hasDateFrom || hasDateTo)) {
				fp.setDate([filterModel.SearchDateFrom, filterModel.SearchDateTo]);
			}
		}

	};

	localApp.GetSearchResults = function () {
		$.ajax({
			url: "/umbraco/surface/LocalSurface/GetSearchResults",
			type: "POST",
			data: filterModel,
			dataType: "html",
			success: function (data) {
				$(".js-search-results").html(data);
				pushHistory();
				localApp.setHeroImage();
				localApp.setPageTitle();
			}
		});
	};

	localApp.GetArticleSearchResults = function () {
		$.ajax({
			url: "/umbraco/surface/LocalSurface/GetArticleSearchResults",
			type: "POST",
			data: filterModel,
			dataType: "html",
			success: function (data) {
				$(".js-search-results-article").html(data);
				pushHistory();
			}
		});
	};

	localApp.GetEventSearchResults = function () {
		$.ajax({
			url: "/umbraco/surface/LocalSurface/GetEventSearchResults",
			type: "POST",
			data: filterModel,
			dataType: "html",
			success: function (data) {
				$(".js-search-results-event").html(data);
				pushHistory();
			}
		});
	};

	$(document).ready(function () {
		fp = $('#filter-date-range').flatpickr({
			enableTime: false,
			altInput: true,
			altFormat: "d M Y",
			dateFormat: "Y-m-d",
			locale: {
				firstDayOfWeek: 1
			},
			mode: "range",
			minDate: "today",
			disableMobile: "true",
			onChange: function (selectedDates, dateStr, instance) {
				if (selectedDates && selectedDates.length == 2) {
					$("#searchDateFrom").val(flatpickr.formatDate(selectedDates[0], "Y-m-d"));
					$("#searchDateTo").val(flatpickr.formatDate(selectedDates[1], "Y-m-d"));
					instance.close();

					//reset quickdate value
					$("#searchQuickDate").val("");
				}
			}
		});


		// Local cookie
		var cookieLocalWard = $.cookie(cookieName);

		//Get url params on load
		const urlParams = new URLSearchParams(window.location.search);
		var hasQueryString = false;

		//check if querystring params exist on load/reload
		if (urlParams.get('search')) {
			filterModel.SearchTerm = decodeURI(urlParams.get('search'));
			hasQueryString = true;
		}

		if (urlParams.get('searchQuickDate')) {
			filterModel.SearchQuickDate = urlParams.get('searchQuickDate');
			hasQueryString = true;
		}

		if (urlParams.get('articlepage')) {
			filterModel.ArticlePage = urlParams.get('articlepage');
			hasQueryString = true;
		}

		if (urlParams.get('eventpage')) {
			filterModel.EventPage = urlParams.get('eventpage');
			hasQueryString = true;
		}

		// get/set/compare cookie
		if (urlParams.get('local')) {
			filterModel.LocalTag = urlParams.get('local');

			if (typeof cookieLocalWard !== 'undefined' && cookieLocalWard !== filterModel.LocalTag) {
				$.cookie(cookieName, filterModel.LocalTag, { expires: 365, path: '/' });
			}
			hasQueryString = true;
		}
		else if (typeof cookieLocalWard !== 'undefined') {
			filterModel.LocalTag = cookieLocalWard;
			hasQueryString = true;
		}


		if (urlParams.get('category')) {
			filterModel.Category = urlParams.get('category');
			hasQueryString = true;
		}

		if (urlParams.get('searchDateFrom')) {
			filterModel.SearchDateFrom = urlParams.get('searchDateFrom');
			hasQueryString = true;
		}
		if (urlParams.get('searchDateTo')) {
			filterModel.SearchDateTo = urlParams.get('searchDateTo');
			hasQueryString = true;
		}

		if (urlParams.get('cost')) {
			filterModel.Cost = urlParams.get('cost');
			hasQueryString = true;
		}

		if (hasQueryString) {
			localApp.setInputValue();
			localApp.setHeroImage();
			localApp.setPageTitle();
		}

		$("#local-search-form").submit(function (e) {
			e.preventDefault();
			getFilterValues();
		});

		function getFilterValues() {
			filterModel.SearchTerm = $("#search").val();
			filterModel.SearchQuickDate = $("#searchQuickDate option:selected").val();
			filterModel.ArticlePage = 1;
			filterModel.EventPage = 1;
			filterModel.LocalTag = $("#area-select").val();
			filterModel.Category = $("#searchCategory").val().join();
			filterModel.Cost = $("#cost").val();

			filterModel.SearchDateFrom = $('#searchDateFrom').val();
			filterModel.SearchDateTo = $('#searchDateTo').val();

			// get/set/compare cookie
			if (filterModel.LocalTag !== null && filterModel.LocalTag !== "") {
				if (typeof cookieLocalWard !== 'undefined' && cookieLocalWard !== filterModel.LocalTag) {
					$.cookie(cookieName, filterModel.LocalTag, { expires: 365, path: '/' });
				}
			}
			else if (filterModel.LocalTag === "") {
				//All Auckland - remove/reset cookie
				$.removeCookie(cookieName, { path: '/' });
			}
			else if (typeof cookieLocalWard !== 'undefined') {
				filterModel.LocalTag = cookieLocalWard;
			}

			localApp.GetSearchResults();
		}


		//on pagination click event
		$(document).on('click', 'ul.pagination a', function (e) {
			e.preventDefault();
			var type = $(this).closest('ul').data('type');
			if (type === "BlogArticle") {
				filterModel.ArticlePage = $(this).data('page');
				localApp.GetArticleSearchResults();
				paginationScrollToTop(".js-search-results-article");
			}
			else if (type === "Event") {
				filterModel.EventPage = $(this).data('page');
				localApp.GetEventSearchResults();
				paginationScrollToTop(".js-search-results-event");
			}
		});

		function paginationScrollToTop(classToScrollTo) {
			$([document.documentElement, document.body]).animate({
				scrollTop: $(classToScrollTo).offset().top - $("header").outerHeight()
			}, 200);
		}


		// copy searchMobile text to search field
		$("#searchMobile").on("keyup paste", function () {
			$("#search").val($(this).val());
		});
	});

})(local);
